import { getData as apiGetData } from 'api/Api'
import {
  addCardFronts
} from '../redux/cards'

type Payload = {
  boardId: number
}

const fetchCardsInBoard = (payload: Payload) => async dispatch => {
  const { boardId } = payload

  const { Cards } = await apiGetData('BoardCards', { boardId })

  dispatch(addCardFronts(Cards))
}

export default fetchCardsInBoard